export default __webpack_public_path__ + "static/media/dashboard-white-18dp.b8bc8efe.svg";